import type { ListBuilderList } from '../../../types';
import { createStandardOrderClientEmbeddedColumns } from '../columns';
import { ORDER_CLIENT_EMBEDDED_REQUIRED_FIELDS } from '../shared';

/**
 * Client Embedded Orders list configuration
 * Orders for today (embedded in client view)
 */
export const clientEmbeddedOrdersList: ListBuilderList = {
	id: 'client-embedded-orders',
	cacheTTL: 600000,
	name: "Today's Orders",
	type: 'default',
	active: true,
	sortOrder: 0,
	columns: createStandardOrderClientEmbeddedColumns(),
	description: 'Orders created today',
	defaultSortId: 'column-dates-desc',
	requiredFields: ORDER_CLIENT_EMBEDDED_REQUIRED_FIELDS,
	filterRules: {
		orderDateRange: {
			defaultValue: [
				{
					id: 'today',
					label: 'Today',
					data: {
						startDate: '{{DATE:0d}}',
						endDate: '{{DATE:0d}}',
					},
				},
			],
		},
		orderStatus: {
			defaultValue: [
				{ id: '2', label: 'Pending' },
				{ id: '3', label: 'Sent to ERP' },
				{ id: '4', label: 'Approved' },
				{ id: '5', label: 'Shipped' },
				{ id: '6', label: 'Held' },
				{ id: '7', label: 'Cancelled' },
				{ id: '8', label: 'Approval Required' },
				{ id: '9', label: 'Override Rejected' },
				{ id: '10', label: 'Cancellation Requested' },
				{ id: '12', label: 'Submitted' },
				{ id: 'Partially Shipped', label: 'Partially Shipped' },
			],
		},
	},
};
